module.exports = __webpack_public_path__ + "static/media/naturplus.8cdd3980.svg";